import { combineReducers } from "redux";
import { resettableReducer } from "reduxsauce";
import { reducer as formReducer } from "redux-form";

import registration from "./registration/reducer";
import login from "./login/reducer";
import data from "./data/reducer";
import staff from "./staff/reducer";
import customer from "./customer/reducer";

const resettable = resettableReducer("RESET");

const rootReducer = combineReducers({
  registration: resettable(registration),
  login,
  data,
  staff,
  customer,
  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers.js